import { webPaths } from "@zplanem/web-paths"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { useAuth } from "../auth-context"
import { getTranslations } from "../i18n"
import { useLocale } from "../locale-context"

export function LandingPage() {
	const { user } = useAuth()
	const { locale } = useLocale()
	const navigate = useNavigate()
	const [currentIndex, setCurrentIndex] = useState(0)

	const t = getTranslations(locale)

	useEffect(() => {
		if (user) {
			navigate(webPaths.dashboard())
		}
	}, [user, navigate])

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentIndex((prev) => (prev + 1) % t.hero.sentences.length)
		}, 5000)
		return () => clearInterval(interval)
	}, [t.hero.sentences.length])

	return (
		<div className="relative min-h-screen w-full flex flex-col items-center justify-center bg-background overflow-hidden px-4">
			<h1 className="text-6xl md:text-8xl font-black tracking-tighter text-foreground mb-8 text-center drop-shadow-2xl">
				{t.appName}
			</h1>

			<div className="relative h-12 w-full max-w-2xl flex items-center justify-center mb-12">
				{t.hero.sentences.map((sentence, index) => (
					<p
						key={`${locale}-${sentence}`}
						className={`absolute text-xl md:text-2xl text-muted-foreground text-center font-medium transition-all duration-700 ease-out ${
							index === currentIndex
								? "opacity-100 translate-y-0 scale-100"
								: "opacity-0 translate-y-4 scale-95 pointer-events-none"
						}`}
					>
						{sentence}
					</p>
				))}
			</div>

			<Button
				variant="brand"
				size="xl"
				onClick={() => navigate(user ? webPaths.dashboard() : webPaths.auth())}
				className="mt-8 get-started-btn-large"
			>
				{t.auth.getStarted}
			</Button>
		</div>
	)
}
